import React from 'react';
import { ArrowRight } from 'lucide-react';
import { caseStudies } from './caseStudyContent';

function proofCard(study) {
  return {
    name: study.customer,
    logo: study.assets.logo,
    headline: study.headline,
    context: study.context,
    href: `/case-studies/${study.slug}`,
    logoClassName: study.assets.proofLogoClassName || undefined,
  };
}

export const caseStudyProofs = {
  manest: proofCard(caseStudies.manest),
  grandGaming: proofCard(caseStudies.grandGaming),
  kinzy: proofCard(caseStudies.kinzy),
};

export default function CaseStudyProof({ items }) {
  const columns =
    items.length >= 3
      ? 'md:grid-cols-2 lg:grid-cols-3'
      : items.length === 2
        ? 'md:grid-cols-2'
        : 'max-w-2xl mx-auto';

  return (
    <div className={`grid grid-cols-1 gap-5 ${columns}`}>
      {items.map((item) => (
        <article
          key={item.href}
          className="flex h-full flex-col rounded-2xl border border-border bg-card p-6 shadow-sm"
        >
          <div className="flex h-14 items-center justify-center overflow-hidden rounded-xl bg-white px-4">
            <img
              src={item.logo}
              alt=""
              className={item.logoClassName || 'h-9 w-auto max-w-[10rem] object-contain'}
            />
          </div>
          <h3 className="mt-5 text-base font-semibold leading-snug text-foreground">
            {item.name}
          </h3>
          <p className="mt-2 text-sm font-medium leading-relaxed text-foreground/90">
            {item.headline}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            {item.context}
          </p>
          <a
            href={item.href}
            className="mt-auto inline-flex min-h-11 items-center gap-1 pt-5 text-sm font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Read Case Study
            <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </article>
      ))}
    </div>
  );
}
